import bus from 'public/utils/bus'
import store from '@/public/store/index.js'
import { ENV } from '@/public/config'


bus.$once('APP_LOADED', init)

function init () {
  setTimeout(() => {
    setQuickTrack()
    setApmUserConfig()
  }, 2000)
}

function setQuickTrack () {
  if (!window.aplus_queue) return
  if (!ENV) return
  let user = store.state.user
  if (user) {
    const userInfo = {
      userid: user.id,
      env_server: ENV.toUpperCase(),
      name: user.name,
      employee_number: user.employeeNumber,
      duty: user.duty,
      duty_id: user.dutyId,
      department_id: user.departmentId,
      department_name: user.department,
      route_department_name: user.departmentInfo && user.departmentInfo.departmentRoute,
    }
    window.aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['_user_id', userInfo.userid] })
    window.aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['globalproperty', userInfo] })
    window.aplus_queue.push({ action: 'aplus.record', arguments: ['$$_user_profile', 'OTHER', userInfo] })
  }
}

function setApmUserConfig() {
  try {
    let user = store.state.user
    if (user) {
      window._apm && window._apm('set', 'puid', user.employeeNumber)
    }
  } catch (error) {
    console.log('【setApmUserConfig】:', error)
  }
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/quick-track-config.js